import { Currency } from '@pancakeswap/sdk'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { ChartEntry } from '@pancakeswap/widgets-internal'
import { TickProcessed } from 'hooks/v3/types'
import { usePoolActiveLiquidity } from 'hooks/v3/usePoolTickData'
import { useCallback, useMemo } from 'react'

export function useDensityChartData({
  currencyA,
  currencyB,
  feeAmount,
}: {
  currencyA: Currency | undefined
  currencyB: Currency | undefined
  feeAmount: FeeAmount | undefined
}) {
  const { isLoading, error, data } = usePoolActiveLiquidity(currencyA, currencyB, feeAmount)

  const formatData = useCallback(() => {
    if (!data?.length) {
      return undefined
    }

    const newData: ChartEntry[] = []

    const dataSort = [...new Set(data.map(d => d.liquidityActive))].sort((a, b) => Number(a - b))
    const diffSort = dataSort.map((d, i) => d - (i > 0 ? dataSort[i - 1] : 0n)).sort((a, b) => Number(a - b))
    const dataMap = {}
    let dAbs = 0
    dataSort.forEach((d, i) => {
      const diff = d - (i > 0 ? dataSort[i - 1] : 0n)
      dAbs += i + diffSort.findIndex(s => s === diff) + 1
      dataMap[String(d)] = dAbs
    })

    for (let i = 0; i < data.length; i++) {
      const t: TickProcessed = data[i]

      const chartEntry = {
        activeLiquidity: dataMap[String(t.liquidityActive)], // Math.log(Number(t.liquidityActive) ** 0.001),
        price0: parseFloat(t.price0),
      }

      if (chartEntry.activeLiquidity > 0) {
        newData.push(chartEntry)
      }
    }

    return newData
  }, [data])

  return useMemo(() => {
    return {
      isLoading,
      error,
      formattedData: !isLoading ? formatData() : undefined,
    }
  }, [isLoading, error, formatData])
}
